
<div>
    <f-title title="Bildarchiv" class="mt-0" />
    <v-row class="no-frame">
        <v-text-field
            label          = "Verzeichnis"
            :readonly      = "readonly"
            v-model        = "unit.imageroot"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
            @input         = "onImageRoot"
            :error-messages = "errors"
        />
    </v-row>
    <v-row class="no-frame mt-2">
        <v-col class="col-12 text-center no-frame">
            <v-btn
                text
                @click = "onInitialize"
                class  = "dialog-button"
                :disabled = "errors.length > 0"
                outlined
            >
                Einplanen
            </v-btn>
        </v-col>
    </v-row>
</div>
